import axios from "axios";

const SITE_HOST = new URL(process.env.REACT_APP_SITE_URL).hostname;
// On the custom domain the backend is served from the same origin, which keeps login cookies first-party
const onSite = [SITE_HOST, `www.${SITE_HOST}`].includes(window.location.hostname);
export const API = `${onSite ? window.location.origin : process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return null;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || null;
  return d.msg || null;
}

export const fileUrl = (jobId, kind, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return `${API}/jobs/${jobId}/${kind}${qs ? `?${qs}` : ""}`;
};

export const hasPlan = (u) => !!u && (u.unlimited || u.role === "admin" || ["active", "trialing"].includes(u.subscription?.status));

export async function downloadFile(jobId, params) {
  try {
    const res = await api.get(`/jobs/${jobId}/download`, { params, responseType: "blob" });
    const cd = res.headers["content-disposition"] || "";
    const utf = /filename\*=UTF-8''([^;]+)/.exec(cd)?.[1];
    const name = (utf && decodeURIComponent(utf)) || /filename="([^"]+)"/.exec(cd)?.[1] || "file";
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try { e.response.data = JSON.parse(await blob.text()); } catch { /* keep */ }
    }
    throw e;
  }
}
